import { apiConstants } from "@data/constants/apiConstants"
import { studyProgramsService } from "@data/services/studyProgramsService"

// ** Initial State
const initialState = {
    studyPrograms: [],
}

function studyPrograms(state = initialState, action) {
    switch (action.type) {
        case studyProgramsService.getStudyProgramsAsStudent.name +
            apiConstants._SUCCESS:
        case studyProgramsService.getStudyProgramsAsTutor.name +
            apiConstants._SUCCESS:
            return {
                ...state,
                studyPrograms: action.data,
            }
        default:
            return state
    }
}

export default studyPrograms
